<script setup>
import { useModalogStore } from "@/stores/modalog.js";
import { useAuthUser } from "@/composables/useAuthUser.js";
import BrandFooter from "./Partials/BrandFooter.vue";
import BrandHeader from "./Partials/BrandHeader.vue";
import BrandToaster from "@/Components/Brand/BrandToaster.vue";
import DashboardHeader from "./Partials/DashboardHeader.vue";

const modalogStore = useModalogStore();
const user = useAuthUser();
</script>

<template>
    <div class="brand min-h-screen bg-brand-cream font-brand text-brand-navy">
        <!-- BrandHeader/BrandFooter carry their own width wrappers -->
        <div v-if="user" class="px-5 pt-5">
            <div class="mx-auto max-w-[1472px]">
                <DashboardHeader />
            </div>
        </div>
        <BrandHeader v-else />

        <!-- pb-5: cream gap between the white card and the navy footer -->
        <main class="px-5 pb-5">
            <!-- overflow-x only: horizontal bleed (promo collages) stays
                 clipped, while popovers like the card Move menu may extend
                 past the card bottom. -->
            <div
                class="mx-auto max-w-[1472px] overflow-x-clip border-t border-brand-tan/40 bg-white"
            >
                <slot />
            </div>
        </main>

        <BrandFooter />

        <!-- Dynamic Modalog (Create List, Delete List, etc.). No mode="in-out"
             here: a modalog whose root v-if toggles closed has no entering
             element, and in-out would defer its leave forever, leaving a dead
             overlay in the DOM. -->
        <transition name="fade">
            <component
                :is="modalogStore.modalogType"
                v-bind="modalogStore.modalogProps"
            ></component>
        </transition>

        <BrandToaster />
    </div>
</template>
